import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _createReducer;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createReducer } from '@reduxjs/toolkit';
import { addCompareDevice, addFavoriteDevice, deleteCompareDevice, deleteFavoriteDevice, setDevices, setDevicesInitialState, setIds } from "../actions/deviceActions";
export var device = createReducer({
  savedShopItems: {
    content: {},
    favorite: {
      ids: [],
      count: 0,
      data: []
    },
    compare: {
      ids: [],
      count: 0,
      data: []
    }
  }
}, (_createReducer = {}, _defineProperty(_createReducer, setDevicesInitialState.type, function (state, action) {
  state.savedShopItems = _objectSpread({
    content: action.payload.content
  }, action.payload.device);
}), _defineProperty(_createReducer, setIds.type, function (state, action) {
  state.savedShopItems[action.payload.type].ids = action.payload.data;
  state.savedShopItems[action.payload.type].count = action.payload.data.length;
}), _defineProperty(_createReducer, setDevices.type, function (state, action) {
  state.savedShopItems[action.payload.type].data = action.payload.data;
}), _defineProperty(_createReducer, deleteFavoriteDevice.type, function (state, action) {
  var devices = [];
  var position = 1;
  state.savedShopItems.favorite.data.forEach(function (item) {
    if (action.payload.data.includes(item.id)) {
      devices.push(_objectSpread(_objectSpread({}, item), {}, {
        position: position
      }));
      position += 1;
    }
  });
  state.savedShopItems.favorite.data = devices;
  if (state.savedShopItems.compare.data.length) {
    state.savedShopItems.compare.data = state.savedShopItems.compare.data.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isAdd: action.payload.data.includes(item.id)
      });
    });
  }
}), _defineProperty(_createReducer, deleteCompareDevice.type, function (state, action) {
  var devices = [];
  var position = 1;
  state.savedShopItems.compare.data.forEach(function (item) {
    if (action.payload.data.includes(item.id)) {
      devices.push(_objectSpread(_objectSpread({}, item), {}, {
        position: position
      }));
      position += 1;
    }
  });
  state.savedShopItems.compare.data = devices;
  if (state.savedShopItems.favorite.data.length) {
    state.savedShopItems.favorite.data = state.savedShopItems.favorite.data.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isAdd: action.payload.data.includes(item.id)
      });
    });
  }
}), _defineProperty(_createReducer, addCompareDevice.type, function (state, action) {
  state.savedShopItems.favorite.data = state.savedShopItems.favorite.data.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      isAdd: action.payload.data.includes(item.id)
    });
  });
}), _defineProperty(_createReducer, addFavoriteDevice.type, function (state, action) {
  state.savedShopItems.compare.data = state.savedShopItems.compare.data.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      isAdd: action.payload.data.includes(item.id)
    });
  });
}), _createReducer));